import BasicLayout from '@/layouts/basic-layout'

const prefix = 'storage-manage-sublease-contract-manage-'
export default [
  {
    path: '/storage-manage/sublease-contract-manage',
    redirect: {name: `${prefix}index`},
    component: BasicLayout,
    children: [
      {
        path: 'index',
        name: `${prefix}index`,
        meta: {title: '转租合同管理'},
        component: () => import('@/pages/storage-manage/sublease-contract-manage/index')
      },
      {
        path: 'detail-edit/:id',
        name: `${prefix}edit`,
        auth: ['hidden'],
        meta: {cache: true, title: '转租合同编辑'},
        component: () => import('@/pages/storage-manage/sublease-contract-manage/detail-edit')
      },

      {
        path: 'detail-view/:id',
        name: `${prefix}view`,
        auth: ['hidden'],
        meta: {title: '转租合同详情'},
        component: () => import('@/pages/storage-manage/sublease-contract-manage/detail-view')
      },
      {
        path: 'payment-status-list/:id',
        name: `${prefix}payment-status-list`,
        auth: ['hidden'],
        meta: {title: '收款情况'},
        component: () => import('@/pages/storage-manage/sublease-contract-manage/payment-status-list')
      }
    ]
  }
]
